import React from 'react';
import './Button.css';

const Button = ({ className, onClick, text, disabled }) => {
  return (
    <button className={className} onClick={onClick} disabled={disabled}>
      {text}
    </button>
  );
};

export default Button;
